import { cn } from "../lib/utils";
import React from "react";
import { Icon } from "./Icon";
import { ListItem } from "./ListItem";
export function ContextItem({ action, children, className, hasSeparator = true, hasSeparatorIfLast = false, subElement, title, visual, hoverAction, onClick, truncateSubElement, }) {
    return (React.createElement(ListItem, { className: className, onClick: onClick, hasSeparator: hasSeparator, hasSeparatorIfLast: hasSeparatorIfLast, groupName: "context-item", itemsAlignment: children ? "start" : "center" },
        visual,
        React.createElement("div", { className: "s-mb-0.5 s-flex s-min-w-0 s-grow s-flex-col s-gap-0" },
            React.createElement("div", { className: "s-flex s-min-w-0 s-grow s-flex-col s-text-foreground dark:s-text-foreground-night sm:s-flex-row sm:s-gap-3" },
                React.createElement("div", { className: cn("s-heading-base", truncateSubElement
                        ? "s-shrink-0"
                        : "s-min-w-0 s-overflow-hidden s-text-ellipsis s-whitespace-nowrap") }, title),
                subElement &&
                    (truncateSubElement ? (React.createElement("div", { className: "s-flex s-min-w-0 s-items-center s-gap-3 s-overflow-hidden s-text-sm s-text-muted-foreground dark:s-text-muted-foreground-night" },
                        React.createElement("div", { className: "s-min-w-0 s-overflow-hidden s-text-ellipsis s-whitespace-nowrap" }, subElement))) : (React.createElement("div", { className: "s-flex s-items-center s-gap-3 s-overflow-hidden s-text-sm s-text-muted-foreground dark:s-text-muted-foreground-night" }, subElement)))),
            children && React.createElement("div", null, children)),
        React.createElement("div", { className: cn(hoverAction &&
                "s-opacity-0 s-transition-opacity s-duration-200 group-hover/context-item:s-opacity-100") }, action)));
}
ContextItem.List = function ({ children, className, hasBorder, }) {
    // Ensure all children are of type ContextItem or ContextItem.SectionHeader
    React.Children.forEach(children, (child) => {
        if (child === null || child === undefined) {
            return;
        }
        if (!React.isValidElement(child) ||
            (child.type !== ContextItem &&
                child.type !== ContextItem.SectionHeader &&
                // all children of child must be of type ContextItem or ContextItem.SectionHeader
                React.Children.toArray(child.props.children).some((c) => !React.isValidElement(c) ||
                    (c.type !== ContextItem && c.type !== ContextItem.SectionHeader)))) {
            throw new Error("All children of ContextItem.List must be of type ContextItem or ContextItem.SectionHeader");
        }
    });
    return (React.createElement("div", { className: cn("s-flex s-flex-col", className, hasBorder &&
            "s-border-b s-border-t s-border-border dark:s-border-border-night") }, children));
};
ContextItem.Description = function ({ children, description, }) {
    return (React.createElement(React.Fragment, null,
        description && (React.createElement("div", { className: "s-text-sm s-font-normal s-text-muted-foreground dark:s-text-muted-foreground-night" }, description)),
        children && React.createElement(React.Fragment, null, children)));
};
ContextItem.Visual = function ({ visual }) {
    return React.createElement(Icon, { size: "md", visual: visual });
};
ContextItem.SectionHeader = function ({ title, description, hasBorder = true, }) {
    return (React.createElement("div", { className: cn("s-flex s-flex-col s-gap-0 s-pb-3 s-pt-7", hasBorder && "s-border-b s-border-border dark:s-border-border-night") },
        React.createElement("div", { className: "s-heading-xl s-text-foreground dark:s-text-foreground-night" }, title),
        description && (React.createElement("div", { className: "s-copy-sm s-text-muted-foreground dark:s-text-muted-foreground-night" }, description))));
};
//# sourceMappingURL=ContextItem.js.map